import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { depositTypes, paymentTermsTypes } from '@features/rates/PaymentTerms.schema';
import { useTranslations } from '@lang';
import { PaymentTerms } from 'shared-types/Common';

export const usePaymentTermsLabel = () => {
  const { t } = useTranslations();
  const intl = useIntl();

  return useCallback(
    (paymentTerms?: PaymentTerms | null): string | null => {
      if (paymentTerms?.type === paymentTermsTypes.DEFERRED_FULL) {
        return t('rates.paymentTerms.payLater');
      }

      if (paymentTerms?.type !== paymentTermsTypes.DEFERRED_PARTIAL) {
        return null;
      }

      const { amountDueNow, depositType, depositPercentage } = paymentTerms;

      if (depositType === depositTypes.PERCENTAGE && !!depositPercentage) {
        return t('rates.paymentTerms.partialPercentage', {
          percentage: intl.formatNumber(depositPercentage / 100, {
            style: 'percent',
            maximumFractionDigits: 2,
          }),
        });
      }

      if (!amountDueNow?.currencyCode) {
        return t('rates.paymentTerms.depositThenBalance');
      }

      const price = intl.formatNumber(amountDueNow.amount / 100, {
        style: 'currency',
        currency: amountDueNow.currencyCode,
      });

      return t('rates.paymentTerms.partial', { price });
    },
    [t, intl]
  );
};
